import React from 'react'
import {
    BackSide,
    Card,
    HeaderBox,
    TitleTypography,
    ImageContent,
    ImageSection,
    ContentSection,
    ContentMessage,
    QuotesEnt,
    QuotesClose,
    ContentQuotes,
    ContentTestimonial,
    FrontSide,
    FlipCard,
    OverCard,
} from './styles'
import { Testimonial } from 'src/types'
import { LineHeight24 } from 'src/components/common/Typography/typography'
import IncomingQuotes from 'src/assets/SuccessStories/commillas-de-entrada.avif'
import ClosingQuotationMarks from 'src/assets/SuccessStories/commillas-de-cierre.avif'
import { useTranslations } from 'src/provider/LocaleProvider'

export const MapTestimonials = ({ image, title, description }: Testimonial) => {
    const t = useTranslations()
    return (
        <OverCard
            marginRight={[0, 0, 0, 'medium']}
            marginBottom={[0, 0, 'xxmedium', 'xlarge']}
            marginLeft={[0, 0, 0, 'medium']}
        >
            <FlipCard className="flip-card">
                <Card className="flip-card-inner">
                    <FrontSide backgroundImage={image}></FrontSide>
                    <BackSide>
                        <HeaderBox>
                            <TitleTypography
                                variant={'h2'}
                                fontSize={[
                                    'xsmall',
                                    'xsmall',
                                    'xxxsmall',
                                    'xxxsmall',
                                ]}
                                fontWeight={400}
                            >
                                {t('testimonials.title')}
                            </TitleTypography>
                            <ImageContent marginBottom={[-32, -32, -32, -42]}>
                                <ImageSection
                                    src={image}
                                    alt={`${title}`}
                                    loading="lazy"
                                />
                            </ImageContent>
                        </HeaderBox>
                        <ContentSection
                            paddingTop={[
                                'large',
                                'large',
                                'xxxlarge',
                                'xxtitle',
                            ]}
                        >
                            <LineHeight24
                                variant={'h2'}
                                fontSize={'xxxsmall'}
                                fontWeight={700}
                            >
                                {title}
                            </LineHeight24>
                            <ContentMessage marginTop={'xxxsmall'}>
                                <ContentQuotes>
                                    <QuotesEnt
                                        src={IncomingQuotes}
                                        alt="IncomingQuotes"
                                    />
                                </ContentQuotes>
                                <QuotesClose>
                                    <QuotesEnt
                                        src={ClosingQuotationMarks}
                                        alt="ClosingQuotationMarks"
                                        loading="lazy"
                                    />
                                </QuotesClose>
                                <ContentTestimonial
                                    variant={'h3'}
                                    fontSize={'small'}
                                    fontWeight={400}
                                >
                                    {description}
                                </ContentTestimonial>
                            </ContentMessage>
                        </ContentSection>
                    </BackSide>
                </Card>
            </FlipCard>
        </OverCard>
    )
}
